import { create } from 'zustand';
import { AlertColor } from '@mui/material';

interface NotificationState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

interface NotificationStore extends NotificationState {
  showNotification: (message: string, severity?: AlertColor) => void;
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  closeNotification: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  open: false,
  message: '',
  severity: 'info',

  showNotification: (message: string, severity: AlertColor = 'info') => 
    set({ open: true, message, severity }),

  showSuccess: (message: string) => 
    set({ open: true, message, severity: 'success' }),

  showError: (message: string) => 
    set({ open: true, message, severity: 'error' }),

  showWarning: (message: string) => 
    set({ open: true, message, severity: 'warning' }),

  showInfo: (message: string) => 
    set({ open: true, message, severity: 'info' }),

  closeNotification: () => set({ open: false }),
}));
